<template>
  <div>
    <span class="d-block mb-4">
      {{ $t('ACADEMICO.DESCRICAO_FORM_PRECOS') }}
    </span>

    <div class="d-flex justify-content-between align-items-center">
      <h6>{{ $t('ACADEMICO.LISTA_DE_PRECOS') }}</h6>
      <b-button
        v-if="!desativarForm"
        variant="primary"
        class="mb-3 "
        @click="abrirModalAdicionarPrecos"
      >
        {{ $t('ACADEMICO.ADICIONAR_PRECO') }}
      </b-button>
    </div>

    <b-table
      head-variant="light"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      :items="form.precos"
      :fields="colunasPrecos"
      show-empty
      responsive
      striped
      hover
    >
      <template #cell(formasPagamento)="item">
        <b-form-select
          v-model="item.item.formaPagamentoId"
          :options="item.item.formasPagamento"
          value-field="id"
          text-field="descricao"
          required
          @change="trocarFormaPagamento(item.item)"
        />
      </template>

      <template #cell(removerPreco)="item" v-if="!desativarForm">
        <b-button variant="secondary" @click="removerPreco(item.item)">
          {{ $t('ACADEMICO.REMOVER') }}
        </b-button>
      </template>
    </b-table>

    <h6 class="d-block mb-3">{{ $t('ACADEMICO.SIMULACAO_PARCELAS') }}</h6>
    <b-table
      :items="planoParcelamentos"
      head-variant="light"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      :fields="colunasPlanoParcelamento"
      show-empty
      responsive
      striped
      hover
    />

    <modal-adicionar-precos
      :form="form"
      :precos="precos"
      :exibir="mostrarModalAdicionarPrecos"
      @fechar="fecharModalAdicionarPrecos"
    />
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import PrecoService from '@/common/services/precos/preco.service';
import ModalAdicionarPrecos from '@/views/academico/aditivo-contratos/components/modais/ModalAdicionarPrecos';

export default {
  name: 'TabelaPrecosAdicionados',
  components: {
    ModalAdicionarPrecos,
  },
  props: {
    form: { type: Object, default: Object },
    filtro: { type: Object, default: Object },
    desativarForm: { type: Boolean, default: false },
  },

  data() {
    return {
      planoParcelamentos: [],
      colunasPlanoParcelamento: [
        {
          key: 'dataVencimento',
          label: this.$t('ACADEMICO.DATA_VENCIMENTO'),
        },
        {
          key: 'competencia',
          label: this.$t('ACADEMICO.COMPETENCIA'),
        },
        {
          key: 'valor',
          label: this.$t('ACADEMICO.VALOR'),
          formatter: (value) => {
            return value ? helpers.formatarReal(value) : '-';
          },
        },
        {
          key: 'parcela',
          label: this.$t('ACADEMICO.PARCELA'),
        },
        {
          key: 'descricao',
          label: this.$t('ACADEMICO.HISTORICO'),
        },
      ],
      colunasPrecos: [
        {
          key: 'descricao',
          label: this.$t('PRECOS.DESCRICAO'),
        },
        {
          key: 'valorBase',
          label: this.$t('PRECOS.VALOR'),
          formatter: (value) => {
            return value ? helpers.formatarReal(value) : '-';
          },
        },
        {
          key: 'formasPagamento',
          label: this.$t('ACADEMICO.FORMA_PAGAMENTO'),
        },
        {
          key: 'removerPreco',
          label: this.$t('PRECOS.REMOVER_PRECO'),
        },
      ],
      mostrarModalAdicionarPrecos: false,
      precoRetiradoTabela: {},
      precos: [],
    };
  },
  mounted() {
    this.getPrecos();
  },
  methods: {
    getPrecos() {
      const precoGrupoTurma = {
        anoLetivoId: this.filtro.anoLetivoId,
        grupoTurmaId: this.filtro.grupoTurmaId,
        cursoId: this.filtro.cursoId,
        gruposTurmas: [this.filtro.grupoTurmaId],
      };
      
      this.$store.dispatch(START_LOADING);
      PrecoService.buscarPrecosPorGrupoTurmaCurso(precoGrupoTurma)
        .then(({ data }) => {
          this.precos = data;
        })
        .catch(() => {
          this.precos = [];
          // mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    trocarFormaPagamento(preco) {
      const indexDoItem = this.form.precos.findIndex((p) => p.id === preco.id);
      if (indexDoItem !== -1) {
        this.$set(
          this.form.precos[indexDoItem],
          'formaPagamentoId',
          preco.formaPagamentoId
        );
      }
      this.$emit('atualizou-preco');
    },

    removerPreco(item) {
      const indexDoItem = this.form.precos.findIndex(
        (preco) => preco.id === item.id
      );
      if (indexDoItem !== -1) {
        this.form.precos.splice(indexDoItem, 1);
      }

      this.getPlanosParcelamento();
    },

    abrirModalAdicionarPrecos() {
      this.mostrarModalAdicionarPrecos = true;
    },

    fecharModalAdicionarPrecos() {
      this.getPlanosParcelamento();
      this.mostrarModalAdicionarPrecos = false;
    },

    getPlanosParcelamento() {
      const payloadParcelamento = this.form.precos.map(preco => {
        return {
          ...preco,
          precoId: preco.id,
        }
      })

      if (!payloadParcelamento?.length) return;

      this.$store.dispatch(START_LOADING);
      PrecoService.buscarPlanosPagamento(payloadParcelamento)
        .then(({ data }) => {
          this.planoParcelamentos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
